export default __webpack_public_path__ + "static/media/Background_00289.9e58abbc.png";